import React from "react";
import { Link } from "react-router-dom";
import rectangleLogo from "/Users/michaeltucker/Documents/coding-projects/client/src/assets/img/rectangle-logo-v2.png";

function AuthLoginMobileLogo() {
  return (
    <div className="auth-login-mobile-logo-wrap">
      <Link to="/" className="auth-login-mobile-logo-link">
        <img
          src={rectangleLogo}
          alt="Lesson Launchpad"
          className="auth-login-mobile-logo"
        />
      </Link>
      <hr className="auth-login-mobile-logo-divider" />
    </div>
  );
}

export default AuthLoginMobileLogo;
